module.exports = __webpack_public_path__ + "img/no_sort.3f551d83.svg";